import { BaseSearchController } from './base_search_controller'

export default class extends BaseSearchController {

  initialize() {
    super.initialize()

    // evita submissão do formulário pois a busca é ao vivo.
    // no home_search é permitido pois ele é levado para a tela de busca
    // de candidaturas (deste componente)
    this.element.addEventListener('submit', (e) => e.preventDefault())
  }

  get fromParam() {
    return 'candidates'
  }

}
